// src/shared/telemetry/KpiTile.tsx
// ────────────────────────────────────────────────────────────────────────────
// Generic KPI tile used across all telemetry dashboards.
// PAC Glass design system — dark glass surface, tabular-nums.
// ────────────────────────────────────────────────────────────────────────────

import React from 'react'

export interface KpiTileProps {
  value: string
  label: string
  accent?: 'emerald' | 'orange' | 'sky' | 'red'
  sub?: string
}

const ACCENT_COLOR: Record<string, string> = {
  emerald: 'text-emerald-400',
  orange:  'text-orange-400',
  sky:     'text-sky-400',
  red:     'text-red-400',
}

export default function KpiTile({ value, label, accent, sub }: KpiTileProps) {
  const valColor = (accent && ACCENT_COLOR[accent]) || 'text-neutral-100'
  return (
    <div className="pac-glass rounded-lg px-3 py-2 min-w-[90px]">
      <div className={`text-lg font-semibold tabular-nums ${valColor}`}>{value}</div>
      <div className="text-[10px] uppercase tracking-wider text-neutral-500">{label}</div>
      {sub && <div className="text-[10px] text-neutral-500 mt-0.5">{sub}</div>}
    </div>
  )
}
